module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCRc4AMP6lbBP.37727938.woff2";